module.exports = __webpack_public_path__ + "img/logo1.232d4ce4.png";